import { defineComponent as _defineComponent } from 'vue'
import GBujianTable from '@/components/g-bujian-table.vue'
import type { PartType } from '@/partTypes'
import MTemplate from '@/views/workShopProduction/components/m-template.vue'
import { bujianStoreSearchKeys } from '@/views/workShopProduction/config'
import moment from 'moment'
import { reactive, ref, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    showDataLength: { default: 12 },
    isManager: { type: Boolean, default: true }
  },
  emits: ['onStartLoading'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { showDataLength: number, isManager: boolean }

const storeTableRef = ref<InstanceType<typeof GBujianTable>>()




const isLoading = ref(false)
const loadingText = ref('')

const state = reactive({
  bujianStore: {
    searchKey: '',
    searchType: '1',
    total: 1,
    page: {
      searchKey: '',
      filterTime: [
        moment().subtract(1, 'month').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
    },
  },
})

const selectData = ref<any[]>([])

/** 删除已选择补件 */
function handleStoreDelete() {
  storeTableRef.value?.handleStoreBatchDelete()
}

/** 搜索 */
function onSearch({ value, selectType }: { value: any; selectType: string }) {
  storeTableRef.value?.search({ ...value, searchType: selectType })
}

/** 跳转排版页面 */
async function handleToPaiban(data: any[]) {
  storeTableRef.value?.handleToPaiban(data)
}

/** 已选择的补件发送变化 */
function handleSelectChange() {
  selectData.value = storeTableRef.value?.getSelectData() ?? []
}

// 添加一个新的补件
function addNewBujian(part: PartType) {
  storeTableRef.value?.addNewBujian(part)
}

function handleStartLoading(data: any) {
  isLoading.value = data.isLoading
  loadingText.value = data.msg
  emits('onStartLoading', data)
}
expose({
  addNewBujian,
})

return { __sfc: true,storeTableRef, emits, props, isLoading, loadingText, state, selectData, handleStoreDelete, onSearch, handleToPaiban, handleSelectChange, addNewBujian, handleStartLoading, GBujianTable, MTemplate, bujianStoreSearchKeys }
}

})